package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.Tag
import com.example.readingnotes.domain.repository.TagRepository

class CreateTagUseCase(
    private val tagRepository: TagRepository,
) {
    suspend operator fun invoke(name: String, color: String? = null): Result<Tag> {
        if (name.isBlank()) {
            return Result.failure(IllegalArgumentException("Tag name cannot be empty"))
        }
        return tagRepository.createTag(name.trim(), color)
    }
}
